import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import buildCriteriaQuery from '@/shared/criteria/criterias';

import { IProduct } from '@/shared/model/product.model';
import { IProductAssociate } from '@/shared/model/product-associate.model';

const productAssociateApi = 'api/product-associates';
const productUpdateApi = 'api/products';

export default class ProductService {
  public find(id: number): Promise<any> {
    return new Promise<IProduct>((resolve, reject) => {
      axios
        .get(`${productUpdateApi}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getAllProductFromProductAssociate(productAssociate: any): IProduct[] {
    const products: IProduct[] = [];
    productAssociate.forEach(prodAsso => {
      if (prodAsso.product) {
        products.push(prodAsso.product);
      }
    });
    return products;
  }

  public findWithLike(companyId: number, supplierId: number, productPart: string, paginationQuery?: any): Promise<any> {
    console.log(supplierId);
    return new Promise<any>((resolve, reject) => {
      axios
        .get(
          `${productUpdateApi}/findWithLike/${companyId.toString()}?supplierId=${supplierId.toString()}&productPart=${productPart.toString()}`
        )
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    // christian
    return new Promise<any>((resolve, reject) => {
      axios
        .get(productAssociateApi + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveProducts(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(productUpdateApi + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveProductsByCriteria(paginationQuery?: any, criteriaQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(productUpdateApi + `?${buildPaginationQueryOpts(paginationQuery)}${buildCriteriaQuery(criteriaQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveByCriteria(paginationQuery?: any, criteriaQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(productAssociateApi + `?${buildPaginationQueryOpts(paginationQuery)}${buildCriteriaQuery(criteriaQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${productUpdateApi}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IProduct): Promise<IProduct> {
    return new Promise<IProduct>((resolve, reject) => {
      axios
        .post(`${productUpdateApi}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IProduct): Promise<IProduct> {
    return new Promise<IProduct>((resolve, reject) => {
      axios
        .put(`${productUpdateApi}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  //todo: verificare se il link è giusto
  public getProductListExport(criteriaQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(productUpdateApi + `/export?${buildCriteriaQuery(criteriaQuery)}`, {
          responseType: 'arraybuffer'
        })

        .then(function(response) {
          if (!window.navigator.msSaveOrOpenBlob) {
            let filename = response.headers.filename;

            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
          } else {
            let filename = response.headers.filename;
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename);
          }
          resolve('success');
        })
        .catch(err => {
          resolve('err: ' + err);
        });
    });
  }
}
